import { AWSelectedPageList } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { userPreferenceApi } from './Base';

export type AWSelectedPageListWithoutMetadata = Pick<AWSelectedPageList, 'name' | 'isDefault' | 'selectedPages'>;

export async function getSavedSelectedPageLists(pkg: string) {
  const path = '/v1/selected-pages';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWSelectedPageList[], 'selectedPages'>>(path, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'selectedPages');
}

export async function getSavedSelectedPageList(id: string) {
  const path = `/v1/selected-pages/${id}`;
  const response = await userPreferenceApi.get<AGraphWrappedType<AWSelectedPageList[], 'selectedPages'>>(path);
  return unwrapAGraphResponse(response, 'selectedPages');
}

export async function postSavedSelectedPageList(selectedPageList: AWSelectedPageListWithoutMetadata, pkg: string) {
  const path = '/v1/selected-pages';
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(path, selectedPageList, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'id');
}

export async function putSavedSelectedPageList(
  selectedPageList: AWSelectedPageListWithoutMetadata,
  id: string,
  pkg: string
) {
  const path = `/v1/selected-pages/${id}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'id'>>(path, selectedPageList, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'id');
}

export function deleteSavedSelectedPageList(id: string) {
  const path = `/v1/selected-pages/${id}`;
  return userPreferenceApi.delete<string>(path);
}
